export default __webpack_public_path__ + "static/media/Collector of Blood.db2e7048.jpg";